// const SHARED =(item) => {
//   let paths={
//   // IMAGE_URL: 'https://images.clipsho.com/images/',
//   // IMAGE_URL_COPY: 'https://images.clipsho.com',
//   // IMAGE_URL_API: 'https://api.clipsho.com/images/',

//   // FILE_URL: 'https://api.clipsho.com/files/',


//   // IMAGE_URL_COPY_API: 'https://api.clipsho.com',



//   // VIDEO_URL: 'https://www.clipsho.com/videos/',
//   // VIDEO_URL_NEW: 'https://www.clipsho.com',
//   // MUSIC_URL: 'https://www.clipsho.com/musics/',
//   // MUSIC_URL_NEW: 'https://www.clipsho.com/mp3/',


//   // url: 'https://api.clipsho.com',

//   // copy_URL: 'https://www.clipsho.com',
//   IMAGE_URL: 'https://api2.ochatt.com/images/',
//   IMAGE_URL_COPY: 'https://api2.ochatt.com/images/',
//   IMAGE_URL_API: 'https://api2.ochatt.com/images/',

//   FILE_URL: 'https://api2.ochatt.com/files/',


//   IMAGE_URL_COPY_API: 'https://api2.ochatt.com',



//   VIDEO_URL: 'https://api2.ochatt.com/videos/',
//   VIDEO_URL_NEW: 'https://api2.ochatt.com',
//   MUSIC_URL: 'https://api2.ochatt.com/musics/',
//   // MUSIC_URL_NEW: 'https://www.clipsho.com/mp3/',


//   url: 'https://api.clipsho.com',

//   copy_URL: 'https://www.clipsho.com',

//   socketServer: 'https://api2.ochatt.com/',
//   // socketServerImage: 'https://api2.ochatt.com/images/',
//   socketServerImage: 'https://images.ochatt.com/images/',

//   socketServerVideo: `https://dl${serverId}.ochatt.com/videos/`,
//   socketServerMusic: `https://dl${serverId}.ochatt.com/musics/`,
//   socketServerFile: `https://dl${serverId}.ochatt.com/files/`,

//   maxBgScale: 10,
//   };
//   retrun ({...paths}
//   )
// };

// export default SHARED;


const SHARED ={

  // IMAGE_URL: 'https://images.clipsho.com/images/',
  // IMAGE_URL_COPY: 'https://images.clipsho.com',
  // IMAGE_URL_API: 'https://api.clipsho.com/images/',

  // FILE_URL: 'https://api.clipsho.com/files/',


  // IMAGE_URL_COPY_API: 'https://api.clipsho.com',



  // VIDEO_URL: 'https://www.clipsho.com/videos/',
  // VIDEO_URL_NEW: 'https://www.clipsho.com',
  // MUSIC_URL: 'https://www.clipsho.com/musics/',
  // MUSIC_URL_NEW: 'https://www.clipsho.com/mp3/',


  // url: 'https://api.clipsho.com',

  // copy_URL: 'https://www.clipsho.com',
  IMAGE_URL: 'https://api2.ochatt.com/images/',
  IMAGE_URL_COPY: 'https://api2.ochatt.com/images/',
  IMAGE_URL_API: 'https://api2.ochatt.com/images/',

  FILE_URL: 'https://api2.ochatt.com/files/',


  IMAGE_URL_COPY_API: 'https://api2.ochatt.com',



  VIDEO_URL: 'https://api2.ochatt.com/videos/',
  VIDEO_URL_NEW: 'https://api2.ochatt.com',
  MUSIC_URL: 'https://api2.ochatt.com/musics/',
  // MUSIC_URL_NEW: 'https://www.clipsho.com/mp3/',


  url: 'https://api.clipsho.com',

  copy_URL: 'https://www.clipsho.com',

  socketServer: 'https://api2.ochatt.com/',
  // socketServerImage: 'https://api2.ochatt.com/images/',
  socketServerImage: 'https://images.ochatt.com/images/',

  socketServerVideo: `https://api2.ochatt.com/videos/`,
  socketServerMusic: `https://api2.ochatt.com/musics/`,
  socketServerFile: `https://api2.ochatt.com/files/`,

  maxBgScale: 10,

};

export default SHARED;